//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { NavigateAsPersons } from './models/NavigateAsPersons';
import type { Person } from './models/Person';
import { Utilities } from './Utilities';

export class PersonsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getNavigateAsPersons: (
			searchTerms?: string,
        ): string => {
            let clientRequestUrl = '/api/v1/persons/navigate-as?';
            if (searchTerms === null) {
                throw new Error(Utilities.parameterErrors.cannotBeNull('searchTerms'));
            } else if (searchTerms !== undefined) {
                clientRequestUrl += `searchTerms=${encodeURIComponent(String(searchTerms))}&`;
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getPerson: (
			id: string,
        ): string => {
            let clientRequestUrl = '/api/v1/persons/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get persons the current user can impersonate
     * @param searchTerms (optional) 
     * @return OK
     */
    async getNavigateAsPersons(
        searchTerms?: string,
    ): Promise<NavigateAsPersons> {
        const clientRequestUrl = this.baseUrl + this.routes.getNavigateAsPersons(
            searchTerms,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<NavigateAsPersons>(_response, false, []);
    }

    /**
     * Get person
     * @return OK
     */
    async getPerson(
        id: string,
    ): Promise<Person> {
        const clientRequestUrl = this.baseUrl + this.routes.getPerson(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<Person>(_response, false, []);
    }
}
